import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-language-configuration-icon',
  imports: [],
  templateUrl: './language-configuration-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './language-configuration-icon.component.scss',
})
export class LanguageConfigurationIconComponent {}
